import styled from "styled-components";
import { ScanCow, ScanCrackerModal } from "../../assets/images";
import { CloseWhite } from "../../assets/icons";

const WarningModal = ({ onClose, message }) => {
  return (
    <StyledWarningModal>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <ModalHeaderCow>
          <SpinWheelModalCow src={ScanCow} />
        </ModalHeaderCow>
        <ModalContent>
          <ModalHeaderContainer>
            <CloseButton onClick={onClose}>
              <CloseIcon src={CloseWhite} />
            </CloseButton>
          </ModalHeaderContainer>
          <ModalHeader>Oops!!!</ModalHeader>
          <Message>
          You've already participated in the contest. Please try again in {message}.
          </Message>
          <Message>Thank you for spinning the wheel! 🎉 </Message>

          <ConfirmButton onClick={onClose}>Ok</ConfirmButton>
        </ModalContent>
      </div>
    </StyledWarningModal>
  );
};

const ConfirmButton = styled.button`
  padding: 1rem;
  background: #55038d;
  border: none;
  color: white;
  border-radius: 0.5rem;
  font-size: 1rem;
  width: 100%;
  margin: 1rem 0;
`;

const CloseIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const CloseButton = styled.button`
  background: transparent;
  outline: none;
  border: none;
`;

const StyledWarningModal = styled.div`
  height: 100vh;
  max-height: 100vh;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  > div {
    overflow: scroll;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 9;
  }
`;

const ModalContent = styled.div`
  height: fit-content;
  width: 85%;
  background: #1c1d21;
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: center;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
`;

const ModalHeaderCow = styled.div`
  display: flex;
  width: 100%;
  height:fit-content;
  object-fit:cover;
  background-image: url(${ScanCrackerModal});
  background-position:center center;
  justify-content: center;
  padding-top: 3rem;
`;

const ModalHeaderContainer = styled.div`
  // padding-bottom: 2.5rem;
  text-align: right;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: end;
`;

const Message = styled.div`
  color: #9b9b9b;
  font-size: 1rem;
  font-weight: 300;
`;

const ModalHeader = styled.div`
  color: white;
  font-size: 1.5rem;
  font-weight: 500;
`;

const SpinWheelModalCow = styled.img`
  width: 6rem;
  // position: relative;
  // top: 10rem;
`;

export default WarningModal;
